function NotificationBingIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.5199C11.59 10.5199 11.25 10.1799 11.25 9.76994V6.43994C11.25 6.02994 11.59 5.68994 12 5.68994C12.41 5.68994 12.75 6.02994 12.75 6.43994V9.76994C12.75 10.1899 12.41 10.5199 12 10.5199Z"
        fill="black"
        className="fill"
      />
      <path
        d="M12.0199 20.35C9.43987 20.35 6.86987 19.94 4.41987 19.12C3.50987 18.82 2.81987 18.17 2.51987 17.35C2.21987 16.53 2.31987 15.59 2.80987 14.77L4.07987 12.65C4.35987 12.18 4.60987 11.3 4.60987 10.75V8.64999C4.60987 4.55999 7.92987 1.23999 12.0199 1.23999C16.1099 1.23999 19.4299 4.55999 19.4299 8.64999V10.75C19.4299 11.29 19.6799 12.18 19.9599 12.65L21.2299 14.77C21.6999 15.55 21.7799 16.48 21.4699 17.33C21.1599 18.18 20.4799 18.83 19.6199 19.12C17.1699 19.95 14.5999 20.35 12.0199 20.35ZM12.0199 2.74999C8.75987 2.74999 6.10987 5.39999 6.10987 8.65999V10.76C6.10987 11.57 5.78987 12.74 5.36987 13.43L4.09987 15.56C3.83987 15.99 3.77987 16.45 3.92987 16.85C4.07987 17.25 4.41987 17.55 4.89987 17.71C9.49987 19.24 14.5599 19.24 19.1599 17.71C19.5899 17.57 19.9199 17.25 20.0699 16.83C20.2299 16.41 20.1799 15.95 19.9499 15.56L18.6799 13.44C18.2599 12.75 17.9399 11.58 17.9399 10.77V8.66999C17.9299 5.39999 15.2799 2.74999 12.0199 2.74999Z"
        fill="black"
        className="fill"
      />
      <path
        d="M11.9999 22.9001C10.9299 22.9001 9.87992 22.4601 9.11992 21.7001C8.35992 20.9401 7.91992 19.8901 7.91992 18.8201H9.41992C9.41992 19.5001 9.69992 20.1601 10.1799 20.6401C10.6599 21.1201 11.3199 21.4001 11.9999 21.4001C13.4199 21.4001 14.5799 20.2401 14.5799 18.8201H16.0799C16.0799 21.0701 14.2499 22.9001 11.9999 22.9001Z"
        fill="black"
        className="fill"
      />
    </svg>
  );
}

export default NotificationBingIcon;
